import React from "react";
import { useTheme } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChairOffice } from "@fortawesome/pro-solid-svg-icons";

const IconSeat = ({ ...props }) => {
  const theme = useTheme();
  return (
    <FontAwesomeIcon
      icon={faChairOffice}
      color={theme.palette.primary.main}
      {...props}
    />
  );
};

export default IconSeat;
